import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { CONTROLLER, LEGAL, LEGAL_LINKS } from "../../lib/legal";

export function LegalSection({ title, children }) {
    return (
        <section className="mb-8">
            {title && <h2 className="font-display-black text-xl mb-3">{title}</h2>}
            <div className="space-y-3 text-sm text-gray-700 leading-relaxed">{children}</div>
        </section>
    );
}

export default function LegalLayout({ title, version, testid, children }) {
    return (
        <div className="min-h-screen bg-white text-slate-100" data-testid={testid}>
            <header className="border-b border-gray-200 sticky top-0 bg-white/90 backdrop-blur z-10">
                <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
                    <Link to="/" data-testid="legal-home-link" className="flex items-center">
                        <img src="/logo-full.png" alt="Asta Intelligence" className="h-24 w-auto mix-blend-screen" />
                    </Link>
                    <Link
                        to="/"
                        className="inline-flex items-center gap-1.5 text-xs font-semibold text-gray-500 hover:text-black transition-colors"
                    >
                        <ArrowLeft size={14} weight="bold" /> Torna alla home
                    </Link>
                </div>
            </header>

            <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
                <div className="overline mb-2">Documento legale · Versione {version}</div>
                <h1 className="font-display-black text-4xl sm:text-5xl mb-2 leading-[0.95]">{title}</h1>
                <p className="text-xs text-gray-500 mb-10">Ultimo aggiornamento: {LEGAL.updated}</p>

                {children}

                <div className="mt-12 pt-8 border-t border-gray-200">
                    <div className="overline mb-2">Titolare del trattamento</div>
                    <p className="text-sm text-gray-700 leading-relaxed">
                        <strong>{CONTROLLER.legalName}</strong><br />
                        {CONTROLLER.address}<br />
                        P.IVA / C.F. {CONTROLLER.vat} · REA {CONTROLLER.rea}<br />
                        PEC: <a className="underline" href={`mailto:${CONTROLLER.pec}`}>{CONTROLLER.pec}</a>
                    </p>
                    <nav className="flex flex-wrap gap-x-5 gap-y-2 mt-6 text-xs">
                        {LEGAL_LINKS.map((l) => (
                            <Link key={l.to} to={l.to} className="font-semibold text-gray-500 hover:text-black underline underline-offset-4">
                                {l.label}
                            </Link>
                        ))}
                    </nav>
                </div>
            </main>
        </div>
    );
}
